import smoothscroll from 'smoothscroll-polyfill';

const scrollTo = ({ link, element, smooth = true }) => {
  smoothscroll.polyfill();

  link.addEventListener('click', (e) => {
    e.preventDefault();

    window.scroll({
      top: element.offsetTop - 120,
      behavior: smooth ? 'smooth' : 'auto'
    })
  })
}

export default scrollTo;
